import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页" },
  { href: "#hot", label: "今日热瓜" },
  { href: "#schedule", label: "每日时段" },
  { href: "#categories", label: "瓜圈分类" },
  { href: "#feed", label: "最新瓜报" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (e: React.MouseEvent, href: string) => {
    e.preventDefault();
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          onClick={(e) => goAnchor(e, "#home")}
          className="flex items-center gap-2"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl text-foreground-900">
            吃瓜<span className="text-primary-600">每日</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => goAnchor(e, l.href)}
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#feed"
            onClick={(e) => goAnchor(e, "#feed")}
            className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
          >
            登录打卡
          </a>
          <a
            href="#signup"
            onClick={(e) => goAnchor(e, "#signup")}
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即吃瓜
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 lg:hidden"
          aria-label="打开导航菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="mx-4 mb-4 rounded-2xl bg-background-50 p-3 shadow-lg lg:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => goAnchor(e, l.href)}
              className="block rounded-lg px-4 py-3 text-sm text-foreground-700 hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#signup"
            onClick={(e) => goAnchor(e, "#signup")}
            className="mt-2 block rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50"
          >
            立即吃瓜
          </a>
        </div>
      )}
    </header>
  );
}